module.exports = __webpack_public_path__ + "img/2.ac841ab5.png";